import ChannelsPanel from "./channels-panel";

export default ChannelsPanel;